import React, { Component } from "react";
import { bookmarkClass } from  '../../utils/bookmarkClass';
import ClassWorkoutVideo from '../home/ClassWorkoutVideo';
import InstructorInfo from '../home/InstructorInfo';
import { openOnDemandClass } from  '../../utils/openOnDemandClass';
import { openLiveClass } from  '../../utils/openLiveClass';
import { connect } from "react-redux";
import { showMainErrorPop } from '../../actions/popups';

class OnDemandClassDetails extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		isOpenActivity: false,
		isOpenEquipment: false,
		sessionData: {},
		isOpenWorkoutVideo: false,
		videoURL: '',
		videoName: '',
		videoDescription: '',
		isOpenInstructorInfo: false,
		isClicked: false
    }
	
	this.bookmarkClass = bookmarkClass.bind(this);
	this.openOnDemandClass = openOnDemandClass.bind(this);
	this.openLiveClass = openLiveClass.bind(this);
}
 
componentDidMount(){
	this.setState({sessionData: this.props.classInfo})
	console.log('classInfo', this.props.classInfo);
}

openCloseWorkout=()=>{
	var isOpenWorkout = this.state.isOpenActivity;
	isOpenWorkout = !isOpenWorkout;
	this.setState({isOpenActivity: isOpenWorkout});
}

openCloseEquipment=()=>{
	var isOpenEq = this.state.isOpenEquipment;
	isOpenEq = !isOpenEq;
	this.setState({isOpenEquipment: isOpenEq});
}

bookMarkClass=(item)=>{
	
	if ( this.props && this.props.failedPaymentStatus )
		{
			return false;	
		}
	
	var sessionDataState = this.state.sessionData;
	var statusClass = 1;
	if ( item.isBookmarked == 1 ) { statusClass = 0; }
	
	var mainthis = this;
	this.bookmarkClass(item.classId, 2, statusClass).then(function(res){
		sessionDataState.isBookmarked = statusClass;
		mainthis.setState({sessionData: sessionDataState});
		mainthis.props.getOnDemandClasses(true, false);
	}, function (err) { 
		if ( err.response && err.response.data && err.response.data.errorData ) 
			{
				mainthis.props.showMainErrorPop(err.response.data.errorData); 
			}
	});
}

playWorkVideo=(item)=>{
	this.setState({isOpenWorkoutVideo: true, videoURL: item.activityVideo, videoName: item.activityName, videoDescription: item.activityDescription})
}

playClass=(id)=>{
	
	if ( ( this.props && this.props.failedPaymentStatus ) || this.state.isClicked )
		{
			return false;	
		}
	
	this.setState({isClicked: true});
	console.log('sessionData', this.state.sessionData);
	var mainthis = this;
	
	if ( this.props && this.props.openFrom && this.props.openFrom == 'bookmarkClasses' )
		{
			window['openOndemandFromBookmark'] = true;	
		}
	else 
		{
			window['openOndemandFromBookmark'] = false;	
		}

	localStorage.removeItem('groupClass');
	this.openLiveClass(id, true);
	
	/* this.openOnDemandClass(id).then(function(res){
		mainthis.props.history.push("/pre-screen");
	}, function (err) { mainthis.props.showMainErrorPop(err); }); */
}

updateStateFromChild=(state)=>{
	this.setState(state);
}

updateClassDetails=(details)=>{
	this.setState({sessionData: details});
}

openInstructorInfo=()=>{
	this.setState({
		isOpenInstructorInfo: true,
	});
}

  render() {
	 const sessionData = this.state.sessionData;
	 
	 return (
		
		
		<div className="details_content">
			{ sessionData && sessionData.classId &&
				<div>
					<div className="top_class_content">
						<div className="class_time">{Math.floor(sessionData.classDuration / 60)} min</div>
						<div className="class_dot">&bull;</div>
						<div className="eye_views"></div>
						<div className="class_time">{sessionData.totalviews}</div>
						<div className="class_interest">{sessionData.interestTitles}</div>
					</div>
					<div className={"left_details_class " + ( ((sessionData.classWorkout && sessionData.classWorkout.length === 0) && sessionData.equipment == '') ? "full_left_details" : "" )}>
						<div className="middle_demand_info">
							<div className="demand_image" >
								<img className="odImgBorder" src={sessionData.classImage} />
							</div>
							<div className="demand_middle_content">
								<div className="demand_name">{sessionData.className}</div>
								<div className="demand_description">{sessionData.description}</div>
							</div>
						</div>
						<div className="detail_buttons_content">
							<div className="active_detail_btn details_button" onClick={() => this.playClass(sessionData.classId)}>
								<span>Start On-demand class
									<div className="play_class"></div>
								</span>
							</div>
							<div className="inactive_detail_btn details_button" onClick={() => this.bookMarkClass(sessionData)}>
								<span>{sessionData.isBookmarked == 1 ? 'Bookmarked' : 'Bookmark'}
									<div className={"inactive_book " + ( sessionData.isBookmarked == 1 ? "bookmarked_details" : "" )}></div>
								</span>
							</div>
						</div>
						<div className="instructor_content_details">
							<div className="instructorInfoHolder" onClick={() => this.openInstructorInfo()} >	
								<div className="instructor_avatar details_avatar" style={{ backgroundImage: sessionData.hostImage && sessionData.hostImage.indexOf('.s3') > -1 ? "url("+sessionData.hostImage+")" : "url(./images/user_avatar.svg)"}}></div>
								<div className="instructor_content_info">
									<div className="instructor_title">Instructor</div>
									<div className="instructor_name_details">{sessionData.hostFirstName} {sessionData.hostLastName}</div>
								</div>
							</div>
							<div className="instructor_text" dangerouslySetInnerHTML={{__html: sessionData.instructorText}}></div>
						</div>
						{ sessionData.musicType && sessionData.musicType !== "" &&
							<div className="session_content">
								<div className="session_content_icon music_icon"></div>
								<div className="session_content_info">
									<div className="session_content_sub">Music</div>
									<div className="session_content_title">{sessionData.musicType}</div>
								</div>
							</div>
						}
						{ sessionData.classHasVirtualEquipment == 1 &&
							<div>
								<div className="session_content">
									<div className="session_content_icon virtual_icon"></div>
									<div className="session_content_info">
										<div className="session_content_sub">Equipment</div>
										<div className="session_content_title">Virtual Equipment</div>
									</div>
								</div>
								<div className="virtual_content">
									<div className="one_virtual_content">
										<div className="virtual_content_title">Requirements</div>
										{ sessionData.virtualRequirements.map((req, i) =>
											<li className="virtual_content_info" key={i}>{req}</li>
										)}
									</div>
									<div className="one_virtual_content">
										<div className="virtual_content_title">Recommendations</div>
										{ sessionData.virtualRecommendations.map((rec, i) =>
											<li className="virtual_content_info" key={i}>{rec}</li>
										)}
									</div>
								</div>
							</div>
						}
					</div>
					{ ((sessionData.classWorkout && sessionData.classWorkout.length > 0) || sessionData.equipment !== '') &&
						<div className="right_details_class">
							<div>
								{ sessionData.classWorkout && sessionData.classWorkout.length > 0 &&
									<div>
										<div className="workout_title workout_demand_title" onClick={this.openCloseWorkout}>Activity List
											<div className={"workout_arrow " + ( this.state.isOpenActivity ? "active_arrow" : "" )}></div>
										</div>
										{ this.state.isOpenActivity &&
											<div>
												{ sessionData.classWorkout.map((item, i) =>
													<div className="work_content" key={i}>
														<div className="work_name">{item.activityName}</div>
														{ item.activityDurationType === 'Time' &&
															<div className="work_duration">{item.activityDuration} Seconds</div>
														}
														{ item.activityDurationType === 'Reps' &&
															<div className="work_duration">{item.activityRepeatNum} sets <span>&bull;</span> {item.activityDuration} seconds</div>
														}
														{ item.activityVideo !== '' &&
															<div className="work_play" onClick={() => this.playWorkVideo(item)}></div>
														}
													</div>
												)}
											</div>
										}
									</div>
								}
							</div>
							<div>
								{ sessionData.equipment !== '' &&
									<div>
										<div className="workout_title workout_demand_title" onClick={this.openCloseEquipment}>Recommended Equipment
											<div className={"workout_arrow " + ( this.state.isOpenEquipment ? "active_arrow" : "" )}></div>
										</div>
										{ this.state.isOpenEquipment &&
											<div className="work_content">
												<div className="work_name">{sessionData.equipment}</div>
											</div>
										}
									</div>
								}
							</div>
						</div>
					}
				</div>
			}
			{ sessionData && !sessionData.classId &&
				<div className="empty_details">Class not available anymore.</div>
			}
			{ this.state.isOpenWorkoutVideo &&
				<ClassWorkoutVideo videoURL={this.state.videoURL} videoName={this.state.videoName} videoDescription={this.state.videoDescription} updateStateFromChild={this.updateStateFromChild}></ClassWorkoutVideo>
			}
			{this.state.isOpenInstructorInfo &&
				<InstructorInfo sessionData={sessionData} updateStateFromChild={this.updateStateFromChild} ></InstructorInfo>
			}
		</div>
    );
  }
}

export default connect(
  null,
  { 
	showMainErrorPop
  },
  null,
  {forwardRef: true}
)(OnDemandClassDetails);
